// import useCustomSnackbar from "../helper/useCustomSnackbar";
// import { useAuth } from '../user/context/AuthContext'

import useCustomSnackbar from "../helper/useCustomSnackbar";
import { useAuth } from "../user/context/AuthContext";

// const useRequest = () => {
//   const token = useAuth()
//   const showSnackbar = useCustomSnackbar();
//   const Request = async (url, config, headers) => {
//     let baseUrl = process.env.REACT_APP_LIVE_BASE_URL_LMS_ADMIN
//     if (headers == null) {
//       headers = new Headers()
//       headers.append('Content-Type', 'application/json; charset=utf-8')
//     }
//     if (token && url.includes('login')) {
//       headers.append('Authorization', token.token)
//       headers.append('Authorization', `Bearer ${token.token}`)
//     }
//     const result = await fetch(`${baseUrl}/${url}`, { headers: headers, ...config })
//     if (!result.ok && result.status === 401 && !url.includes('login')) {
//       let res = await result.json()
//       localStorage.clear()
//       showSnackbar('error', res?.message ? res?.message : 'Session expired, Please login again')
//       window.location.href = '/login';
//     }
//     let response;
//     try {
//       response = await result.json()
//     } catch (error) {
//       response = await result.text()
//     }
//     return response;
//   }
//   return Request;
// }

// export default useRequest;





const useRequest = () => {
  const token = useAuth();
  const showSnackbar = useCustomSnackbar();

  const Request = async (url, config, headers) => {
    let baseUrl = process.env.REACT_APP_LIVE_BASE_URL_LMS_ADMIN;

    if (!headers) {
      headers = new Headers();
      headers.append("Content-Type", "application/json; charset=utf-8");
    }

    if (token && !url.includes("login")) {
      headers.append("Authorization", `Bearer ${token.token}`);
    }

    const result = await fetch(`${baseUrl}/${url}`, { headers, ...config });

    if (!result.ok && result.status === 401 && !url.includes("login")) {
      let res;
      try {
        res = await result.json();
      } catch (error) {
        res = { message: "Session expired, Please login again" };
      }

      localStorage.clear();
      showSnackbar("error", res?.message);
      window.location.href = "/login";
    }


    let responseBody;
    const contentType = result.headers.get("Content-Type");

    if (contentType && contentType.includes("application/json")) {
      responseBody = await result.json();
    } else {
      responseBody = await result.text();
    }

    return responseBody;
  };

  return Request;
};

export default useRequest;
